import { Routes, RouterModule } from '@angular/router';
import { guardarCodigoReutilizableComponent } from './guardar-codigo-reutilizable.component';
import { NgModule } from '@angular/core';

const routes: Routes = [
    { path: '', component: guardarCodigoReutilizableComponent }
  ];
  
  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  
  export class guardarCodigoReutilizableRouting { }